import React from 'react';
import { Input } from 'src/components/input';
import { TextInput } from 'src/components/text-input';
import { DateInput } from 'src/components/date-input';
import { Upload } from 'src/components/upload';
import { CalendarOutlined, InfoCircleOutlined, EnvironmentOutlined, BookOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Select } from '../components/select';
import { ReportCopy } from '../components/reportCopy';


const incidentTypeList = [
  'incident',
  'unsafe-situation',
  'unsafe-action',
  'possible-danger',
];

export function IncidentInformation() {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <DateInput
        name='date'
        placeholder={t('placeholder.date')}
        icon={<CalendarOutlined />}
      />
      <Input
        name='project'
        placeholder={t('placeholder.project')}
        icon={<BookOutlined />}
      />
      <Input
        name='responsible-person'
        placeholder={t('placeholder.responsible-person')}
      />
      <Input
        name='place'
        placeholder={t('placeholder.place')}
        icon={<EnvironmentOutlined />}
      />
      <Select
        label={t('placeholder.incident')}
        placeholder={t('placeholder.incident')}
        name='incident'
        namespace='incident'
        options={incidentTypeList}
      />
      <TextInput
        name='description'
        placeholder={t('placeholder.description')}
        icon={<InfoCircleOutlined />}
        rows={4}
      />
      <TextInput
        name='cause'
        placeholder={t('placeholder.cause')}
        icon={<InfoCircleOutlined />}
        rows={4}
      />
      <TextInput
        name='actions'
        placeholder={t('placeholder.actions')}
        icon={<InfoCircleOutlined />}
        rows={4}
      />
      <Upload
        name='photo'
        placeholder='Enter incident photo'
      />
      <ReportCopy
        name='reportCopy'
        inputName='reportEmail'
        text={t('placeholder.report.check')}
        placeholder={t('placeholder.report.input')}
      />
    </React.Fragment>
  );
}
